<app-header *ngIf="showHead"></app-header>
<div class="app_container">
  <router-outlet></router-outlet>
</div>